import { render, staticRenderFns } from "./CandidateAcademicData.vue?vue&type=template&id=24275b90&scoped=true"
import script from "./CandidateAcademicData.vue?vue&type=script&lang=js"
export * from "./CandidateAcademicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24275b90",
  null
  
)

export default component.exports